import FootballState from "../../state/football-state";
import ContinuedStats from "./continued-stats";

export default class IndoorContinuedStats extends ContinuedStats {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const hasReboundNet = play.getFirstFragment(
            FootballState.HitReboundNet
        );
        const hasBarBall = play.getFirstFragment(FootballState.HitGoalpost);

        if (hasReboundNet || hasBarBall) {
            return false;
        }

        return super.applicable(gameContext, ruleContext, eventConfiguration, {
            play,
            fragment
        });
    }
}
